// Auto-generated image library — 50 background + 50 content images
// Tech-premium aesthetic: deep dark gradients, frosted glass, cinematic.

const bgModules = import.meta.glob("./bg/*.jpg", { eager: true, query: "?url", import: "default" }) as Record<string, string>;
const contentModules = import.meta.glob("./content/*.jpg", { eager: true, query: "?url", import: "default" }) as Record<string, string>;

function sortedUrls(mods: Record<string, string>): string[] {
  return Object.keys(mods).sort().map((k) => mods[k]);
}

export const backgrounds: string[] = sortedUrls(bgModules);
export const contents: string[] = sortedUrls(contentModules);

export function pickBg(i: number): string {
  return backgrounds[((i % backgrounds.length) + backgrounds.length) % backgrounds.length];
}
export function pickContent(i: number): string {
  return contents[((i % contents.length) + contents.length) % contents.length];
}
